import polyglotI18nProvider from 'ra-i18n-polyglot';
import ru from 'ra-language-russian';

const messages: Record<string, any> = {
    ru: {
        ...ru,
        ra: {
            ...ru.ra,
            auth: {
                username: 'Логин',
                password: 'Пароль',
                sign_in: 'Войти',
                logout: 'Выйти',
            },
            action: {
                ...ru.ra.action,
                search: 'Поиск',
                export: 'Экспорт',
                delete: 'Удалить',
                create: 'Создать',
                edit: 'Редактировать',
                show: 'Показать',
                save: 'Сохранить',
                cancel: 'Отмена',
                undo: 'Отменить',
                confirm: 'Подтвердить',
                add: 'Добавить',
                remove: 'Удалить',
                refresh: 'Обновить',
                close: 'Закрыть',
                'clear_input': 'Очистить ввод',
                expand: 'Развернуть',
                fold: 'Свернуть',
                filter: 'Фильтр',
                back: 'Назад',
                bulk_actions: '{{smart_count}} выбрано',
            },
            notification: {
                ...ru.ra.notification,
                updated: 'Элемент обновлен ||| {{smart_count}} элементов обновлено',
                created: 'Элемент создан',
                deleted: 'Элемент удален ||| {{smart_count}} элементов удалено',
                bad_item: 'Неверный элемент',
                item_doesnt_exist: 'Элемент не существует',
                http_error: 'Ошибка связи с сервером',
                data_loaded: 'Данные загружены ||| {{smart_count}} элементов загружено',
                undone: 'Отмена выполнена',
                'salvaged': 'Элемент восстановлен',
                'canceled': 'Отменено',
                'error': 'Ошибка',
                'not_found': 'Не найдено',
                'already_exists': 'Уже существует',
                'invalid_form': 'Неверная форма',
                'validation_error': 'Ошибка валидации',
                'logged_in': 'Вы вошли в систему',
                'logged_out': 'Вы вышли из системы',
            },
            page: {
                ...ru.ra.page,
                list: 'Список {{name}}',
                edit: 'Редактировать {{name}} #{{id}}',
                show: 'Показать {{name}} #{{id}}',
                create: 'Создать {{name}}',
                dashboard: 'Панель управления',
                not_found: 'Не найдено',
                loading: 'Загрузка...',
            },
            input: {
                ...ru.ra.input,
                file: {
                    upload_several: 'Перетащите файлы для загрузки или нажмите, чтобы выбрать',
                    upload_single: 'Перетащите файл для загрузки или нажмите, чтобы выбрать',
                },
                image: {
                    upload_several: 'Перетащите изображения для загрузки или нажмите, чтобы выбрать',
                    upload_single: 'Перетащите изображение для загрузки или нажмите, чтобы выбрать',
                },
                references: {
                    all_missing: 'Не удается найти ссылочные данные.',
                    many_missing: 'Не удалось найти по крайней мере одну ссылку.',
                    single_missing: 'Не удалось найти ссылочные данные.',
                },
                autocomplete: {
                    empty: 'Очистить',
                    no_results: 'Ничего не найдено.',
                    'select_first': 'Выберите первый элемент из списка',
                    'select_item': 'Выбрать элемент',
                    'clear_input': 'Очистить ввод',
                    'close': 'Закрыть',
                    'open': 'Открыть',
                },
            },
            message: {
                ...ru.ra.message,
                about: 'О программе',
                not_found: 'Неверный URL',
                are_you_sure: 'Вы уверены?',
                'no_results': 'Не найдено результатов',
                'no_more_results': 'Нет больше результатов',
                loading: 'Загрузка...',
            },
            navigation: {
                ...ru.ra.navigation,
                no_results: 'Нет результатов по выбранным критериям',
                no_more_results: 'У нас больше нет страниц для отображения',
                page_out_of_bounds: 'Страница {{page}} выходит за границы',
                page_out_of_bounds_error: 'Номер страницы {{page}} выходит за границы',
                page_range_info: '{{offsetBegin}}-{{offsetEnd}} из {{total}}',
                next: 'Вперед',
                prev: 'Назад',
            },
            auth_check: 'Пожалуйста, войдите, чтобы продолжить',
            search: 'Поиск',
            validation: {
                ...ru.ra.validation,
                required: 'Обязательное поле',
                minLength: 'Должен быть не менее {{min}} символов',
                maxLength: 'Должен быть не более {{max}} символов',
                minValue: 'Должен быть не менее {{min}}',
                maxValue: 'Должен быть не более {{max}}',
                number: 'Должно быть числом',
                email: 'Должен быть действительным адресом электронной почты',
                url: 'Должен быть действительным URL',
                date: 'Должен быть действительной датой',
                dateTime: 'Должен быть действительной датой и временем',
                array: 'Должен быть массивом',
                boolean: 'Должен быть булевым значением',
                null: 'Должен быть null',
                unique: 'Должен быть уникальным',
                regex: 'Неверный формат',
            },
        },
    },
};

const i18nProvider = polyglotI18nProvider((locale) => messages[locale], 'ru');

export default i18nProvider; 